import { post } from "../../service/api";

const AddVatMerchant = async (data,merchantId) => {
    try {
        const response = await post(`/merchant/${merchantId}/vatMerchant`,data);
        return response.data;
    } catch (error) {
        console.error('Error AddVatMerchant:', error);
        throw error;
    }
};

export default AddVatMerchant;